import { gql } from 'apollo-boost';
export const LEAVE_SHARED_FOLDER = gql`
    mutation leaveSharedFolder($folderId: ID!) {
        leaveSharedFolder(folderId: $folderId)
    }
`;
